import React from 'react';
import '../assets/styles/Community.css';
const AppFoodCommunity = () => {
    return (
        <div className="community">
            <h2 className="community-title">Welcome to Our Food Community</h2>
            <p className="community-paragraph">
                Welcome to our food community! We’re a group of like-minded individuals who share a passion for cooking and nutrition. Whether you're a seasoned chef, a home cook, or just someone who cares about what you eat, we invite you to join us in exploring the endless possibilities of delicious and nutritious food. Here, you’ll find a variety of nutritional tools designed to help you make informed choices, share recipes, and connect with others who are as passionate about healthy living as you are. Let's cook, learn, and grow together in our journey towards better health and well-being.
            </p>
        </div>
    );
};

export default AppFoodCommunity;
